import React from 'react';
import MUIEditIcon from '@mui/icons-material/Edit';
import { SvgIconProps } from '@mui/material/SvgIcon';

const EditIcon = ({
  color,
  ...rest
}: SvgIconProps) => (
  <MUIEditIcon
    color={color ?? 'primary'}
    {...rest}
  />
);

export default EditIcon;
